import api from '@/apis/dashboard/dashboardCashBalanceDepositAPI';
import Chart from '@/stores/baseChart';
const chart = new Chart('cashBalanceDeposit', api);

const state = {
  ...chart.state,
  avaItems: []
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
  /**
   * Load dữ liệu chart cho ava phân tích
   * @param {*} context context
   * @param {*} payload payload
   * NBTIN 03.06.2024
   */
  async avaLoad(context, payload) {
    let res = null;
    if (!api) {
      throw new Error('Chưa khai báo api');
    }
    if (typeof api.getChartData !== 'function') {
      throw new Error('Chưa định nghĩa hàm getChartData');
    }
    try {
      context.commit('updateLoading', true);
      res = await api.getChartData(payload || {});
      if (res) {
        context.commit('setAvaItems', res);
      } else {
        console.warn('Chart Data empty');
      }
    } finally {
      context.commit('updateLoading', false);
    }
    return res;
  },
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * NBTIN 03.06.2024
   */
  setAvaItems(context, payload) {
    context.commit('setAvaItems', payload);
  },
};
const mutations = {
  ...chart.mutations,
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * HTHIEP 21.06.2023
   */
  setAvaItems(state, data) {
    state.avaItems = data;
  },
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};